import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#9E233B",
        d: "m19.0726 35.2817 6.2253-4.1502-4.7575-3.0368-2.1763 7.187c.1518.0506.4049.1012.7085 0"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#BC3347",
        d: "m41.0892 12-34.467 7.3388c-.7086.1518-.8604 1.1135-.2024 1.4678l9.7175 4.8081L41.646 12.1012C41.4941 12 41.2411 12 41.0892 12"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#E0485E",
        d: "M42.0004 12.7083c0-.2531-.0506-.4049-.2025-.5062L20.4901 28.0944l12.3494 7.8955c.4049.2531.9617.0506 1.1641-.4049l7.9968-22.6743z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#7F132D",
        d: "M41.6964 12.1016 16.1878 25.6151l1.7714 9.2114c.0506.1012.1519.3037.405.4555l2.1763-7.187 21.3078-15.8922c-.0506-.0506-.1013-.1012-.1519-.1012"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#660C0C",
        d: "M32.4853 30.676c-.4049.2025-.8604.3037-1.4171.3037-.5062 0-.9617-.1012-1.3666-.2531s-.7592-.4049-1.0628-.658c-.3037-.3036-.5568-.6579-.7086-1.0628s-.2531-.8604-.2531-1.3665.1012-.9617.2531-1.3666.4049-.7592.7086-1.0628c.3036-.3037.6579-.5062 1.1134-.658.4049-.1518.8604-.2531 1.3666-.2531.4555 0 .8604.1013 1.3159.2531s.7592.4049 1.0628.7086l-1.0122 1.0122c-.1518-.2024-.3543-.3543-.5567-.4555-.2531-.1012-.4556-.1518-.7086-.1518q-.3796 0-.7592.1518c-.2024.1012-.4049.2531-.5567.4049-.1519.1519-.3037.3543-.3543.6073q-.1518.3797-.1518.7592c0 .3037.0506.5568.1518.8099s.2024.4555.3543.6073c.1518.1518.3543.3037.5567.4049.2025.1012.4555.1518.7086.1518.3037 0 .5567-.0506.8098-.2024.2024-.1013.4049-.2531.5567-.4555l1.0629 1.0122c-.3543.3037-.7086.5568-1.1135.7592"
    }, "4")
], "AppCampaigns", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
